import { render, staticRenderFns } from "./Tournament2021.vue?vue&type=template&id=d98b6e6a&scoped=true"
import script from "./Tournament2021.vue?vue&type=script&lang=js"
export * from "./Tournament2021.vue?vue&type=script&lang=js"
import style0 from "./Tournament2021.vue?vue&type=style&index=0&id=d98b6e6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98b6e6a",
  null
  
)

export default component.exports